import styled from 'styled-components';

import { colours } from 'themes/default';

const spacer = '16px';

export const SegmentDivider = styled.div`
  + div {
    margin-top: ${spacer};
    padding-top: ${spacer};
    border-top: 1px solid ${colours.Greyscale.MistGrey};
  }
`;
